<template>
    <b-table :items="invites" :fields="fields">
        <template #cell(displayName)="row">
            <a :href="inviteUrl(row.item.inviteId)">
                {{ row.item.displayName }}
            </a>
        </template>

        <template #cell(inviteId)="data">
            <b-button @click="inviteToClipboard(data.value)">
                copy link to clipboard
            </b-button>
        </template>
    </b-table>
</template>

<script>
import api from "@/api";

export default {
    name: "InviteList",
    props: {
        sessionId: {
            type: String,
        },
    },
    data() {
        return {
            invites: [],
            fields: [
                { key: "displayName", label: "Guest Name", sortable: true },
                { key: "inviteId", label: "Invite", sortable: false },
            ],
        };
    },
    computed: {},
    methods: {
        inviteUrl(inviteId) {
            return process.env.VUE_APP_INVITE_BASE_URL + inviteId;
        },

        inviteToClipboard(inviteId) {
            let url = this.inviteUrl(inviteId);
            this.clipboard(url); // uses global mixin
        },

        clipboard(str) {
            const el = document.createElement("textarea");
            el.addEventListener("focusin", (e) => e.stopPropagation());
            el.value = str;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        },

        async loadInvites() {
            let result = await api.invites.getBySessionId(this.sessionId);

            let { error, message, results } = result;
            if (error) {
                console.error(message);
                return;
            }

            let { invites } = results;
            this.invites = invites;
        },
    },

    components: {},

    beforeMount() {
        this.loadInvites();
    },
};
</script>